// extracted by mini-css-extract-plugin
export var completionBody = "_mc-2";
export var completionCard = "_mc-0";
export var completionFooter = "_mc-3";
export var completionTitle = "_mc-1";